export default "__VITE_ASSET__C1T6zaBd__"